module.exports = __webpack_public_path__ + "img/possibility@2x.afd948b5.png";